//---------------------------------
//	Modals
//---------------------------------

export function Modals($) {

	// Модальное окно - Заказать звонок
	(function(){
		$('#modalCallback').on('show.bs.modal', function (e) {

			if ($(e.relatedTarget).data('modal-title') !== undefined) {
				$('#modalCallback .modal-title h4').html($(e.relatedTarget).data('modal-title'));
			}
			if ($(e.relatedTarget).data('modal-subtitle') !== undefined) { 
				$('#modalCallback .modal-title p').html($(e.relatedTarget).data('modal-subtitle'));
			}
			if ($(e.relatedTarget).data('modal-button') !== undefined) {
				$('#modalCallback .submit span').html($(e.relatedTarget).data('modal-button'));
			}
			if ($(e.relatedTarget).data('modal-form-name') !== undefined) {
				$('#modalCallback input[name=form_name]').val($(e.relatedTarget).data('modal-form-name'));
			}
			if ($(e.relatedTarget).data('modal-ya-goal-name') !== undefined) {
				$('#modalCallback input[name=ya_metrica_goal_name]').val($(e.relatedTarget).data('modal-ya-goal-name'));
			}
			if ($(e.relatedTarget).data('modal-success') !== undefined) {
				$('#modalCallback input[name=modal_success]').val($(e.relatedTarget).data('modal-success'));
			}
			if ($(e.relatedTarget).data('modal-download') !== undefined) {
				let fileUrl = $(e.relatedTarget).data('modal-download');
	
				// if ($(e.relatedTarget).data('modal-download-mobile') !== undefined) {
				// 	if (window.innerWidth <= 768) fileUrl = $(e.relatedTarget).data('modal-download-mobile');
				// }
	
				$('#modalCallback input[name=download_file]').val(fileUrl);
			}

			if ($(e.relatedTarget).data('modal-textarea') !== undefined && $(e.relatedTarget).data('modal-textarea') !== '') {
				const html = '<div class="form-group textarea"><label>Сообщение</label><textarea required class="form-control" name="' + $(e.relatedTarget).data('modal-textarea') + '" required></textarea></div>';

				$('#modalCallback .form-group-set').append(html);
			}
			

		});

		$('#modalCallback').on('hidden.bs.modal', function (e) {
			$('#modalCallback .modal-title h4').html('Оставить заявку');
			$('#modalCallback .modal-title p').html('и мы свяжемся с вами в течении 5 минут');
			$('#modalCallback .submit span').html('Отправить');
			$('#modalCallback .form-group-set .textarea').remove();
			$('#modalCallback input[name=form_name]').val('Обратный звонок');
			$('#modalCallback input[name=ya_metrica_goal_name]').val('');
			$('#modalCallback input[name=modal_success]').val('modalSuccess');
			$('#modalCallback input[name=download_file]').val('');
		});
	})();



	// Модальное окно - Один отзыв
	(function(){
		$('#modalReviewView').on('show.bs.modal', function (e) {
			if ($(e.relatedTarget).data('post-id') !== undefined) {
				const id = $(e.relatedTarget).data('post-id');

				$.ajax({
                    type: "POST",
                    url: globalParams.ajax_url,
                    data: {
						id: id,
						action: 'view_review'
					},
                    success: function(res) {
						if (res && res !== undefined && res !== '') {
                        	$('#modalReviewView .review-single').html(res);
						}
                    },
                    error: function(e) {
                        console.log(e)
                        
                    }
                });
			}
		});

		$('#modalReviewView').on('hidden.bs.modal', function (e) {
			$('#modalReviewView .review-single').html('');
		});
	})();

}


